import React from 'react';
import PropTypes from 'prop-types';
import {USER_DATA} from 'user/user-prop-types';
import classNames from 'classnames';
import {connect} from 'react-redux';
import {compose} from 'redux';
import withConfig from 'config/withConfig';
import {resetSelectedSpot} from 'spot/spot-actions';
import {userLogout} from 'user/user-actions';
import Navigation from './Navigation';

const HeaderDesktop = ({
    className,
    isProduction,
    user,
    expandedData,
    collapsedData,
    clearSelectedSpot,
    onUserLogout,
}) => {
    const classes = classNames('Header', className);

    return (
        <header className={classes} role="banner">
            <Navigation
                isProduction={isProduction}
                user={user}
                collapsedData={collapsedData}
                expandedData={expandedData}
                onItemSelected={clearSelectedSpot}
                onUserLogout={onUserLogout}
            />
        </header>
    );
};

HeaderDesktop.propTypes = {
    className: PropTypes.string,
    isProduction: PropTypes.bool,
    user: PropTypes.shape(USER_DATA).isRequired,
    expandedData: PropTypes.array.isRequired,
    collapsedData: PropTypes.array.isRequired,
    clearSelectedSpot: PropTypes.func.isRequired,
    onUserLogout: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
    const {
        user: {data: userData},
    } = state;

    return {
        user: userData,
    };
};

const mapDispatchToProps = {
    clearSelectedSpot: resetSelectedSpot,
    onUserLogout: userLogout,
};

const enhance = compose(
    withConfig(['isProduction']),
    connect(mapStateToProps, mapDispatchToProps)
);

export default enhance(HeaderDesktop);
